/* eslint-disable indent */
import React, { useEffect, useMemo, useState } from "react";
import AppLayout from "../../components/AppLayout";
import styles from "./Tag.module.css";
import { Box, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, Grid, IconButton, Modal, Paper, Slide, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, ThemeProvider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { useTheme } from "@emotion/react";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { visuallyHidden } from "@mui/utils";
import PropTypes from "prop-types";
import { VendaService } from "../../service/venda_service";
import { OrdemProducaoService } from "../../service/ordem_producao_service";
import { PDFViewer } from "@react-pdf/renderer";
import PdfHangTags12x5 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags12x5";
import PdfHangTags16x5 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags16x5";
import PdfHangTags6x4 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags6x4";
import QRGenerator from "../../components/PdfQrcodeLayout/QrCodeGeneration";
import PdfHangTags6x8 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags6x8";
import PdfHangTags10x10 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags10x10";
import PdfHangTags10x7 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags10x7";
import PdfHangTags9x3 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags9x3";
import PdfHangTags3x3 from "../../components/PdfQrcodeLayout/pdfQrcodeComponents/PdfHangTags3x3";
import { useParams } from "react-router-dom";
import EditableTag from "../../components/EditableTag";

//material ul imports
const theme = createTheme(
	{
		palette: {
			primary: { main: "#1976d2" },
		},
	},
	ptBR
);

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	width: 100,
	height: "70vh",
	maxHeight: "80vh",
	transform: "translate(-50%, -50%)",
};

const stylesItem = {
	bgcolor: "rgba(0, 0, 0, 0)",
	border: "none",
	boxShadow: "none",
	display: "flex",
	alignItems: "stretch",
	justifyContent: "stretch",
	widths: "auto",
	m: 0,
	p: 0,
	minHeight: "45px",
	minWidth: "40vw",
};

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
	color: theme.palette.text.secondary,
}));

function TablePaginationActions(props) {
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<Box sx={{ flexShrink: 0, ml: 2.5 }}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
			</IconButton>
		</Box>
	);
}

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function EnhancedTableHead(props) {
	const {  order, orderBy,  onRequestSort,columns} =
    props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead className={styles.tableGenerator}>
			<TableRow>
				{columns.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={ "left"}
						padding={ "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<Box component="span" sx={visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
				<TableCell></TableCell>
			</TableRow>
		</TableHead>
	);
}

EnhancedTableHead.propTypes = {
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(["asc", "desc"]).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const columnForVenda = [
	{
		id: "customerName",
		label:"Cliente",
	},
	{
		id: "saleNumber",
		label:"Número da venda",
	},
	{
		id: "fiscalNote",
		label:"Nota fiscal",
	},
	{
		id: "expeditionDate",
		label:"Data de expedição",
	},
];

const columnsForVendaItem = [
	{
		id:"produto",
		label: "Produto",
	},
	{
		id:"loteRastreabilidade",
		label: "Lote de Rastreabilidade",
	},
	{
		id:"quantidade",
		label:"Quantidade",
	},
	{
		id:"volumes",
		label: "Volumes",
	},
	{
		id:"numeroOP",
		label:"Número da OP",
	},
];

let currentSaleId = "";
let currentOPId = "";

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function Tag() {
	const { id } = useParams();

	const keysForVenda = columnForVenda;
	const keysForVendaItem = columnsForVendaItem;

	const [selectedSale, setSelectedSale] = useState(null);
	const [saleItem, setSaleItem] = useState(null);
	const [size, setSize] = useState("GerarQrcodeEtiqueta6x4");
	const [codeBar] = useState("0");
	const [distributor, setDistributor] = useState(false);
	const [favorite, setFavorite] = useState(false);
	const [doubleTag, setDoubleTag] = useState(false);
	const [openSale, setOpenSale] = useState(false);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState(keysForVenda[0].id);
	const [sales, setSales] = useState([]);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(7);
	const [openSaleDialog, setOpenSaleDialog] = useState(false);
	const [openSaleItem, setOpenSaleItem] = useState(false);
	const [order1, setOrder1] = useState("asc");
	const [orderBy1, setOrderBy1] = useState(keysForVenda[0].id);
	const [saleItems, setSaleItems] = useState([]);
	const [page1, setPage1] = React.useState(0);
	const [rowsPerPage1, setRowsPerPage1] = React.useState(7);
	const [openSaleItemDialog, setOpenSaleItemDialog] = useState(false);
	const [qrCodeData, setQrCodeData] = useState([]);

	const [saleItemId, setSaleItemId] = useState(null);
	const [saleId, setSaleId] = useState(null);
	const [qrCodeIds, setQrCodeIds] = useState(null);
	const [showDistributor, setShowDistributor] = useState(null);
	const [showDoubleTag, setShowDoubleTag] = useState(null);
	const [showExpiryDateState, setShowExpiryDateState] = useState(null);
	const [codBar1Type, setCodBar1Type] = useState(null);
	const [codBar2Type, setCodBar2Type] = useState(null);
	const [selectedSize, setSelectedSize] = useState(null);
	const [reloadPDF, setReloadPDF] = useState(0);
	const [showExpiryDate] = useState(false);
	const [editableTagData, setEditableTagData] = useState(null);
	const [useEditableMode, setUseEditableMode] = useState(false);
	const [isGeneratingTag, setIsGeneratingTag] = useState(false);

	async function qrCodeVenda(opId, numeroVenda) {
		const ordemProducaoData = await ordemProducaoService.getById(opId);
		// Um único parâmetro com o código de rastreio inteiro. O portal espera o
		// código composto (venda + lote), não os dois campos separados.
		const codigo = `${numeroVenda}-${ordemProducaoData.loteRastreabilidade || ordemProducaoData.numeroOP}`;
		const baseDoPortal = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
		const qrcode = [
			{
				id: 1,
				value: `${baseDoPortal}/rastreabilidade?id=${encodeURIComponent(codigo)}`,
			},
		];
		setQrCodeData(qrcode);
		return qrcode;
	}

	const vendaService = new VendaService();
	const ordemProducaoService = new OrdemProducaoService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const initData = async () => {
		try {
			const unidadeDistribuidoraId = localStorage.getItem("selected_unidade_id");

			if (!unidadeDistribuidoraId) {
				console.error("Nenhuma unidade distribuidora selecionada");
				return;
			}

			const salesData = await vendaService.getAll(unidadeDistribuidoraId);

			if (!salesData || !Array.isArray(salesData)) {
				console.error("Dados de vendas inválidos");
				return;
			}

		const salesMapped = salesData.map((sale) => {
			return {
				id: sale.id,
				customerId: sale.clienteId,
				customerName: sale.cliente?.nome || "Cliente não informado",
				saleNumber: sale.numeroVenda ?? "Não informado",
				fiscalNote: sale.notaFiscal ?? "-",
				expeditionDate: new Date(sale.dataExpedicao).toLocaleDateString("pt-BR", { timeZone: "UTC" }),
				itens: sale.itens || [],
			};
		});

		console.log("Vendas carregadas:", salesMapped);
		setSales(salesMapped);

		if(salesData.length > 0 ){
			const selectedSalesById = salesData.filter((saleToCheck) => saleToCheck.id === id);
			let selectedSaleById = null;
			if(selectedSalesById.length > 0){
				selectedSaleById = selectedSalesById[0];
				if(selectedSaleById) {
					setSelectedSale({
						id: selectedSaleById.id,
						customerId: selectedSaleById.clienteId,
						customerName: selectedSaleById.cliente.nome,
						saleNumber: selectedSaleById.numeroVenda ?? "Não informado",
						fiscalNote: selectedSaleById.notaFiscal ?? "-",
						expeditionDate: new Date(selectedSaleById.dataExpedicao).toLocaleDateString("pt-BR", { timeZone: "UTC" }),
					});
				}
			} else {
				// Se não encontrou por ID, usa a primeira venda
				selectedSaleById = salesData[0];
				setSelectedSale({
					id: salesData[0].id,
					customerId: salesData[0].clienteId,
					customerName: salesData[0].cliente.nome,
					saleNumber: salesData[0].numeroVenda ?? "Não informado",
					fiscalNote: salesData[0].notaFiscal ?? "-",
					expeditionDate: new Date(salesData[0].dataExpedicao).toLocaleDateString("pt-BR", { timeZone: "UTC" }),
				});
			}

			const currentSaleItems = [];

			// Verifica se selectedSaleById existe e tem itens
			if (selectedSaleById && selectedSaleById.itens) {
				selectedSaleById.itens.forEach((item) => {
				// Formar o nome do produto a partir de cultura e variedade
				const cultura = item.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
				const variedade = item.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
				const nomeProduto = cultura && variedade
					? `${cultura} ${variedade}`
					: cultura || variedade || "Produto não informado";

				currentSaleItems.push({
					id: item.id,
					ordemProducaoId: item.ordemProducaoId,
					numeroOP: item.ordemProducao?.numeroOP || "Não informado",
					produto: nomeProduto,
					loteRastreabilidade: item.ordemProducao?.loteRastreabilidade || "Não informado",
					quantidade: item.quantidade.toString().replace(".",","),
					volumes: item.volumes,
					embalagemId: item.ordemProducao?.embalagemProdutoFinalId,
				});
				});
			}

			setSaleItems(currentSaleItems);
			if(currentSaleItems.length > 0)
				setSaleItem(currentSaleItems[0]);
		}
		} catch (error) {
			console.error("Erro ao carregar dados iniciais:", error);
		}
	};

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === "asc";
		setOrder(isAsc ? "desc" : "asc");
		setOrderBy(property);
	};

	const handleOpenSale = () => {
		setOpenSale(true); //abre o modal
	};
	const handleCloseSale = () => {
		setOpenSale(false); //fecha o modal
	};

	const handleRequestSort1 = (event, property) => {
		const isAsc = orderBy1 === property && order1 === "asc";
		setOrder1(isAsc ? "desc" : "asc");
		setOrderBy1(property);
	};

	const handleOpenSaleItem = () => {
		setOpenSaleItem(true); //abre o modal
	};
	const handleCloseSaleItem = () => {
		setOpenSaleItem(false); //fecha o modal
	};

	async function generateTag() {
		try {
			// Validações
			if (!selectedSale) {
				alert("Por favor, selecione uma venda primeiro.");
				return;
			}
			if (!saleItem) {
				alert("Por favor, selecione um item da venda primeiro.");
				return;
			}

			console.log("Gerando etiqueta para:", { selectedSale, saleItem });

			// Desabilitar renderização temporariamente
			setIsGeneratingTag(true);

			const qrCodeData = await qrCodeVenda(
				saleItem.ordemProducaoId,
				selectedSale.saleNumber,
			);
			const type1 = "EAN13";
			const type2 = "CODE128";

			setQrCodeIds(qrCodeData.map((data) => data.id));

		let codBar1Value = null;
		let codBar2Value = null;

		if (codeBar === type1) {
			codBar1Value = type1;
			codBar2Value = null;
			setCodBar1Type(type1);
			setCodBar2Type(null);
		} else if (codeBar === type2) {
			codBar1Value = null;
			codBar2Value = type2;
			setCodBar1Type(null);
			setCodBar2Type(type2);
		} else if (codeBar === "all") {
			codBar1Value = type1;
			codBar2Value = type2;
			setCodBar1Type(type1);
			setCodBar2Type(type2);
		} else if (codeBar === "0") {
			codBar1Value = null;
			codBar2Value = null;
			setCodBar1Type(null);
			setCodBar2Type(null);
		}

		const saleIdValue = selectedSale.id;
		const saleItemIdValue = saleItem.ordemProducaoId;
		const qrCodeIdsValue = qrCodeData.map((data) => data.id);

		console.log("Valores para PDF:", {
			saleIdValue,
			saleItemIdValue,
			qrCodeIdsValue,
			codBar1Type: codBar1Value,
			codBar2Type: codBar2Value,
			showDistributor: distributor ? "0" : "",
			showDoubleTag: doubleTag ? "0" : "",
			showExpiryDate,
			size
		});

		// Preparar dados para o editor HTML primeiro (antes de setar os estados do PDF)
		await prepareEditableTagData(codBar1Value, codBar2Value);

		// Agora setar todos os estados
		setSaleId(saleIdValue); // ID da venda, não do item
		setShowDistributor(distributor ? "0" : "");
		setShowDoubleTag(doubleTag ? "0" : "");
		setShowExpiryDateState(showExpiryDate);
		setSelectedSize(size);
		setSaleItemId(saleItemIdValue); // ID da ordem de produção
		setReloadPDF(reloadPDF + 1);

		// Ativar modo editável e desabilitar loading
		setUseEditableMode(true);
		setIsGeneratingTag(false);
		} catch (error) {
			console.error("Erro ao gerar etiqueta:", error);
			alert(`Erro ao gerar etiqueta: ${error.message || "Erro desconhecido"}`);
			setIsGeneratingTag(false);
		}
	}

	async function prepareEditableTagData(codBar1Value, codBar2Value) {
		try {
			console.log("Preparando dados da etiqueta...");
			const vendaData = await vendaService.getById(selectedSale.id);
			console.log("Dados da venda:", vendaData);

			if (!vendaData) {
				throw new Error("Não foi possível carregar os dados da venda");
			}

			const ordemProducaoData = await ordemProducaoService.getById(saleItem.ordemProducaoId);
			console.log("Dados da ordem de produção:", ordemProducaoData);

			if (!ordemProducaoData) {
				throw new Error("Não foi possível carregar os dados da ordem de produção");
			}

			// Buscar dados da unidade distribuidora (produtor para etiqueta)
			const unidadeDistribuidora = vendaData.unidadeDistribuidora || {
				nome: localStorage.getItem("selected_unidade_nome") || "Unidade Distribuidora",
				cnpj: localStorage.getItem("selected_unidade_cnpj") || "",
				endereco: localStorage.getItem("selected_unidade_endereco") || "",
				bairro: localStorage.getItem("selected_unidade_bairro") || "",
				cidade: localStorage.getItem("selected_unidade_cidade") || ""
			};

		// Obter QR Code
		const qrCodeElement = document.getElementById("1");
		let qrCodeUrl = null;
		if (qrCodeElement)
			qrCodeUrl = qrCodeElement.toDataURL();

		// Gerar código de barras CODE128 (codBar1) - código do PRODUTO/PRODUTOR
		if (codBar1Value !== null && ordemProducaoData.produtoFinal?.codigoDeBarra) {
			const barCodeCanvas = document.createElement("canvas");
			let barCodeValue = ordemProducaoData.produtoFinal.codigoDeBarra.padStart(12, "0");

			const JsBarcode = (await import("jsbarcode")).default;
			JsBarcode(barCodeCanvas, barCodeValue, {
				format: barCodeValue?.length === 13 ? "EAN13" : "CODE128",
				width: 3,
				fontSize: 16,
				height: 120,
			});
		}

		// Gerar código de barras EAN13/PLU (codBar2) - código do CLIENTE (se houver)
		if (codBar2Value !== null) {
			// Aqui pode ser implementado código de barras do cliente se necessário
			// Similar ao sisagri-campo, mas usando dados do cliente da venda
		}

		const formatCpfCnPJ = (value) => {
			if (!value) return "";
			if (value.length > 11) {
				return (
					value.substring(0, 2) +
					"." +
					value.substring(2, 5) +
					"." +
					value.substring(5, 8) +
					"/" +
					value.substring(8, 12) +
					"." +
					value.substring(12)
				);
			} else {
				return (
					value.substring(0, 3) +
					"." +
					value.substring(3, 6) +
					"." +
					value.substring(6, 9) +
					"-" +
					value.substring(9)
				);
			}
		};

		// Calcular peso baseado na embalagem
		let peso = "Não informado";
		if (ordemProducaoData.embalagemProdutoFinal?.quantidade && ordemProducaoData.embalagemProdutoFinal?.unidadeMedida?.sigla) {
			peso = `${ordemProducaoData.embalagemProdutoFinal.quantidade} ${ordemProducaoData.embalagemProdutoFinal.unidadeMedida.sigla}`;
		}

		// Formar o nome do produto a partir de cultura e variedade
		const cultura = ordemProducaoData.produtoFinal?.cultivo?.cultura || "";
		const variedade = ordemProducaoData.produtoFinal?.cultivo?.variedade || "";
		const nomeProduto = cultura && variedade
			? `${cultura} ${variedade}`
			: cultura || variedade || "Produto não informado";

		// Montar informações do produtor
		const producerDocument = unidadeDistribuidora.cpf_cnpj
			? (unidadeDistribuidora.cpf_cnpj.length > 11
				? `CNPJ: ${formatCpfCnPJ(unidadeDistribuidora.cpf_cnpj)}`
				: `CPF: ${formatCpfCnPJ(unidadeDistribuidora.cpf_cnpj)}`)
			: "";

		const producerAddress = unidadeDistribuidora.endereco
			? [
				unidadeDistribuidora.endereco.logradouro || unidadeDistribuidora.endereco.endereco,
				unidadeDistribuidora.endereco.bairro,
				[unidadeDistribuidora.endereco.cidade, unidadeDistribuidora.endereco.uf].filter(Boolean).join(" - ")
			].filter(Boolean).join(", ")
			: "";

		// Montar informações do distribuidor (cliente)
		const distributorDocument = distributor && vendaData.cliente?.cpfCnpj
			? (vendaData.cliente.cpfCnpj.length > 11
				? `CNPJ: ${formatCpfCnPJ(vendaData.cliente.cpfCnpj)}`
				: `CPF: ${formatCpfCnPJ(vendaData.cliente.cpfCnpj)}`)
			: "";

		const distributorAddress = distributor && vendaData.cliente?.endereco
			? [
				vendaData.cliente.endereco.logradouro || vendaData.cliente.endereco.endereco,
				vendaData.cliente.endereco.bairro,
				[vendaData.cliente.endereco.cidade, vendaData.cliente.endereco.uf].filter(Boolean).join(" - ")
			].filter(Boolean).join(", ")
			: "";

		const tagData = {
			culture: nomeProduto,
			weight: peso,
			trackingCode: `${vendaData.numeroVenda}-${ordemProducaoData.loteRastreabilidade || ordemProducaoData.numeroOP}`,
			producer: {
				name: unidadeDistribuidora.nome || "Não informado",
				document: producerDocument,
				address: producerAddress
			},
			distributor: distributor && vendaData.cliente ? {
				name: vendaData.cliente.nome || "Não informado",
				document: distributorDocument,
				address: distributorAddress
			} : null,
			dates: {
				packaging: ordemProducaoData.data ? new Date(ordemProducaoData.data).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : null,
				delivery: new Date(vendaData.dataExpedicao).toLocaleDateString("pt-BR", { timeZone: "UTC" }),
				expiry: null // Data de validade não é usada no distribuidor
			},
			qrCode: qrCodeUrl,
			barCode: null, // Código de barras não é usado no distribuidor
			barCodePLU: null
		};

		console.log("Tag data preparada:", tagData);

		setEditableTagData(tagData);
		} catch (error) {
			console.error("Erro ao preparar dados da etiqueta:", error);
			alert(`Erro ao preparar etiqueta: ${error.message}`);
			throw error;
		}
	}

	const visibleRows = useMemo(
		() =>
			stableSort(sales, getComparator(order, orderBy)),
		[order, orderBy, sales]
	);

	const visibleRows1 = useMemo(
		() =>
			stableSort(saleItems, getComparator(order1, orderBy1)),
		[order1, orderBy1, saleItems]
	);

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0)
				return order;

			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}

	function getComparator(order, orderBy) {
		return order === "desc"
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	let dataAllSales = [];
	let dataAllSaleItems = [];

	sales.map((item, index) => {
		return dataAllSales.push({
			id: item.id,
			customerName: item.customerName,
			saleNumber: item.saleNumber,
			fiscalNote: item.fiscalNote,
			expeditionDate: item.expeditionDate,
			index: index,
		});
	});

	saleItems.map((item, index) => {
		return dataAllSaleItems.push({
			id: item.id,
			ordemProducaoId: item.ordemProducaoId,
			produto: item.produto,
			loteRastreabilidade: item.loteRastreabilidade,
			quantidade: item.quantidade,
			volumes: item.volumes,
			numeroOP: item.numeroOP,
			index: index,
		});
	});

	const handleOpenSaleItemDialog = (e) => {
		currentOPId = e.target.id;
		setOpenSaleItemDialog(true); //abre o modal
	};

	const handleCloseAddSaleItem = () => {
		console.log("Selecionando item com OP ID:", currentOPId);
		console.log("Itens disponíveis:", saleItems);
		const currentSaleItems = saleItems.filter((saleItemToTest) => saleItemToTest.ordemProducaoId === currentOPId);
		console.log("Itens filtrados:", currentSaleItems);
		if(currentSaleItems.length === 1) {
			setSaleItem(currentSaleItems[0]);
			console.log("Item selecionado:", currentSaleItems[0]);
		}
		setOpenSaleItem(false); //fecha o modal
		setOpenSaleItemDialog(false);
	};

	const handleCloseSaleItemDialog = () => {
		setSaleItem(null);
		setOpenSaleItemDialog(false); //fecha o modal
	};

	const handleChangePage1 = (event, newPage) => {
		setPage1(newPage); //paginação
	};

	const handleChangeRowsPerPage1 = (event) => {
		setRowsPerPage1(+event.target.value); //paginação
		setPage1(0);
	};

	const handleOpenSaleDialog = (e) => {
		currentSaleId = e.target.id;
		setOpenSaleDialog(true); //abre o modal
	};

	const handleCloseAddSale = async () => {
		try {
			const currentSales = sales.filter((saleToTest) => saleToTest.id === currentSaleId);
			if(currentSales.length === 1) {
				setSelectedSale(currentSales[0]);

				// Carregar detalhes completos da venda
				const vendaCompleta = await vendaService.getById(currentSaleId);

				if (!vendaCompleta || !vendaCompleta.itens) {
					console.error("Dados da venda incompletos");
					setOpenSale(false);
					setOpenSaleDialog(false);
					return;
				}

				const currentSaleItems= [];

				vendaCompleta.itens.forEach((item) => {
					// Formar o nome do produto a partir de cultura e variedade
					const cultura = item.ordemProducao?.produtoFinal?.cultivo?.cultura || "";
					const variedade = item.ordemProducao?.produtoFinal?.cultivo?.variedade || "";
					const nomeProduto = cultura && variedade
						? `${cultura} ${variedade}`
						: cultura || variedade || "Produto não informado";

					currentSaleItems.push({
						id: item.id,
						ordemProducaoId: item.ordemProducaoId,
						numeroOP: item.ordemProducao?.numeroOP || "Não informado",
						produto: nomeProduto,
						loteRastreabilidade: item.ordemProducao?.loteRastreabilidade || "Não informado",
						quantidade: item.quantidade.toString().replace(".",","),
						volumes: item.volumes,
						embalagemId: item.ordemProducao?.embalagemProdutoFinalId,
					});
				});

				setSaleItems(currentSaleItems);
				if(currentSaleItems.length > 0)
					setSaleItem(currentSaleItems[0]);
			}
		} catch (error) {
			console.error("Erro ao carregar detalhes da venda:", error);
		}
		setOpenSale(false); //fecha o modal
		setOpenSaleDialog(false);
	};

	const handleCloseSaleDialog = () => {
		setSelectedSale(null);
		setOpenSaleDialog(false); //fecha o modal
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage); //paginação
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value); //paginação
		setPage(0);
	};

	const tagPdf = useMemo(() => {
		if (selectedSize === "GerarQrcodeEtiqueta6x4" && saleItemId && saleId && qrCodeIds){
			return (<PdfHangTags6x4
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}

		if (selectedSize === "GerarQrcodeEtiqueta12x5" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags12x5
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta16x5" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags16x5
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta6x8" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags6x8
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta10x10" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags10x10
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta9x3" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags9x3
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta3x3" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags3x3
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
			/>);
		}
		if (selectedSize === "GerarQrcodeEtiqueta10x7" && saleItemId && saleId && qrCodeIds) {
			return (<PdfHangTags10x7
				key={reloadPDF}
				item={saleItemId}
				venda={saleId}
				ids={qrCodeIds}
				codBar1Type={codBar1Type}
				codBar2Type={codBar2Type}
				checkDist={showDistributor}
				doubleTag={showDoubleTag}
				showExpiryDate={showExpiryDateState}
			/>);
		}
	}, [reloadPDF, selectedSize, saleItemId, saleId, qrCodeIds, codBar1Type, codBar2Type, showDistributor, showDoubleTag, showExpiryDateState]);

	return (
		<AppLayout currentPage="etiquetas">
			<Box sx={{ maxWidth: 1400, mx: "auto", height: "calc(100vh - 180px)", overflow: "hidden", boxSizing: "border-box", position: "relative" }}>
				<Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", boxSizing: "border-box" }}>
					{/* Título */}
					<Box sx={{ py: 1, flexShrink: 0 }}>
						<h1 style={{ margin: "8px 0" }}>Etiquetas</h1>
					</Box>

					{/* Container dos painéis */}
					<Box sx={{ flex: 1, display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 1.5, minHeight: 0, overflow: "hidden" }}>
						{/* Painel de Campos - 50% */}
						<Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: "flex" }}>
							<Box
								sx={{
									width: "100%",
									height: "100%",
									bgcolor: "white",
									borderRadius: 4,
									p: 2,
									overflow: "auto",
									display: "flex",
									flexDirection: "column",
								}}
							>
								<Grid container rowSpacing={2} columnSpacing={2} direction={"column"} sx={{ width: "100%", m: 0 }}>
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "start",
											alignItems: "center",
										}}
									>
										<p>
											<b>Venda</b>
										</p>
									</Grid>

									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
										className={styles.registrationInputModal}
									>
										<Box sx={{
											border: "1px solid rgba(0,0,0,0.3)",
											borderRadius: "8px",
											width: "100%",
											display: "flex",
											justifyContent: "flex-start",
											flexDirection: "row",
											alignItems: "center",
											px: 1,
											pr:2,
											position: "relative",
											m:0
										}}>
											<div
												className={styles.noErrControl}
											>
												<input
													type="text"
													id="sale"
													disabled
													value={selectedSale?.saleNumber ?? ""}
													className={styles.inputRequestItem}
												>
												</input>
											</div>
											<button
												onClick={handleOpenSale}
												type="button"
												className={styles.ButtonConfirm}
											>
												Selecionar
											</button>
										</Box>
									</Grid>

									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "start",
											alignItems: "center",
										}}
									>
										<p>
											<b>Item da Venda (Ordem de Produção)</b>
										</p>
									</Grid>

									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
										className={styles.registrationInputModal}
									>
										<Box sx={{
											border: "1px solid rgba(0,0,0,0.3)",
											borderRadius: "8px",
											width: "100%",
											display: "flex",
											justifyContent: "flex-start",
											flexDirection: "row",
											alignItems: "center",
											px: 1,
											pr:2,
											position: "relative",
											m:0
										}}>
											<div
												className={styles.noErrControl}
											>
												<input
													type="text"
													id="saleItem"
													disabled
													value={saleItem?.produto ?? ""}
													className={styles.inputRequestItem}
												>
												</input>
											</div>
											<button
												onClick={handleOpenSaleItem}
												type="button"
												className={styles.ButtonConfirm}
											>
												Selecionar
											</button>
										</Box>
									</Grid>
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "start",
											alignItems: "center",
										}}
									>
										<p>
											<b>Modelo de etiquetas</b>
										</p>
									</Grid>

									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
										className={styles.registrationInputModal}
									>
										<select
											id="size"
											onChange={(event) => setSize(event.target.value)}
											value={size}
										>
											<option value={"GerarQrcodeEtiqueta6x4"}>Etiqueta 6cm x 4cm</option>
											<option value={"GerarQrcodeEtiqueta6x8"}>Etiqueta 6cm x 8cm</option>
											<option value={"GerarQrcodeEtiqueta10x10"}>Etiqueta 10cm x 10cm</option>
											<option value={"GerarQrcodeEtiqueta10x7"}>Etiqueta 10cm x 7cm</option>
											<option value={"GerarQrcodeEtiqueta9x3"}>Etiqueta 9cm x 3cm</option>
											<option value={"GerarQrcodeEtiqueta3x3"}>Etiqueta 3cm x 3cm</option>
											<option value={"GerarQrcodeEtiqueta12x5"}>Etiqueta 12cm x 5cm</option>
											<option value={"GerarQrcodeEtiqueta16x5"}>Etiqueta 16cm x 5cm</option>
										</select>
									</Grid>
									<Grid
										item
										xs={12}
										sm={12}
										md={12}
										sx={{
											paddingTop: 0,
											marginTop: 0,
											alignItems: "center",
										}}
										className={styles.registrationInputModalFav}
									>
										<input
											type="checkbox"
											checked={favorite}
											onChange={() => setFavorite(!favorite)}
										/>
										<span>
											<b> Salvar como favorito</b>
										</span>
									</Grid>
									{size !== "GerarQrcodeEtiqueta3x3" && (
										<>
											<Grid
												item
												xs={12}
												sm={12}
												md={12}
												sx={{
													alignItems: "center",
												}}
												className={styles.registrationInputModal}
											>
												<input
													type="checkbox"
													checked={distributor}
													onChange={() => setDistributor(!distributor)}
												/>
												<span>
													<b> Informação do cliente</b>
												</span>
											</Grid>

											<Grid
												item
												xs={12}
												sm={12}
												md={12}
												sx={{
													alignItems: "center",
												}}
												className={styles.registrationInputModal}
											>
												<input
													type="checkbox"
													checked={doubleTag}
													onChange={() => setDoubleTag(!doubleTag)}
												/>
												<span>
													<b> Etiqueta dupla</b>
												</span>
											</Grid>
										</>
									)}

									<Grid size={{ xs: 12, sm: 12, md: 12 }} sx={{ marginTop: 5 }}>
										<Grid
											container
											rowSpacing={{ xs: 2, sm: 1, md: 0 }}
											columnSpacing={{ xs: 1, sm: 2, md: 3 }}
											display="flex"
											alignItems="center"
											justifyContent="end"
											flexDirection={{
												xs: "column-reverse",
												sm: "column-reverse",
												md: "row",
											}}
										>
											<Grid size={{ xs: 12, sm: 12, md: 12 }}>
												<button
													className={styles.registrationButtoncadastrar}
													type="button"
													onClick={generateTag}
												>
													Gerar etiqueta
												</button>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</Box>
						</Box>

						{/* Painel de Etiqueta - 50% */}
						<Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: "flex" }}>
							<Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
								{isGeneratingTag ? (
									<Box
										sx={{
											width: "100%",
											height: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											bgcolor: "#f5f5f5",
											borderRadius: 4,
											p: 3,
										}}
									>
										<p style={{ textAlign: "center", color: "#666" }}>
											Gerando etiqueta...
										</p>
									</Box>
								) : useEditableMode && editableTagData ? (
									<EditableTag
										initialData={editableTagData}
										size={selectedSize?.replace("GerarQrcodeEtiqueta", "") ?? size.replace("GerarQrcodeEtiqueta", "")}
										doubleTag={showDoubleTag === "0"}
									/>
								) : saleItemId && saleId && selectedSize ? (
								<PDFViewer
									style={{
										width: "100%",
										height: "100%",
										border: "none",
										boxShadow: "none",
										backgroundColor: "#525659",
									}}
								>
									{tagPdf}
								</PDFViewer>
							) : (
								<Box
									sx={{
										width: "100%",
										height: "100%",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										bgcolor: "#f5f5f5",
										borderRadius: 4,
										p: 3,
									}}
								>
									<p style={{ textAlign: "center", color: "#666" }}>
										Selecione uma venda e um item para gerar a etiqueta
									</p>
								</Box>
								)}
							</Box>
						</Box>
					</Box>

					{/* QR Code generators (hidden) */}
					<Box sx={{ position: "absolute", left: "-9999px", top: "-9999px" }}>
						{qrCodeData.map((data) => {
							if (
								size === "Etiqueta 16 x 5" ||
								size === "GerarQrcodeEtiqueta16x5"
							) {
								return (
									<div key={data.id}>
										<QRGenerator value={data.value} documentId={data.id} />
									</div>
								);
							} else {
								return (
									<div key={data.id}>
										<QRGenerator value={data.value} documentId={data.id} margin={true} />
									</div>
								);
							}
						})}
					</Box>
				</Box>
			</Box>

			<Modal
				open={openSale}
				onClose={handleCloseSale}
				aria-labelledby="parent-modal-title"
				aria-describedby="parent-modal-description"
			>
				<Box
					sx={{
						...style,
						width: { xs: "90%", sm: "50%", md: "50%" },
						bgcolor: "white",
						borderRadius: "8px",
						p: 3,
					}}
				>
					<Grid
						container
						rowSpacing={0}
						columnSpacing={{ xs: 0, sm: 2, md: 3 }}
						sx={stylesItem}
						className={styles.registrationInputModal}
					>
						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<div className={styles.titleTabelaModal}>
								<h2>
									<b>Vendas</b>
								</h2>
							</div>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<Paper sx={{ width: "100%", p: 1, m: 0 }}>
								<ThemeProvider theme={theme}>
									<TableContainer sx={{ maxHeight: "46vh" }}>
										<Table stickyHeader>
											<EnhancedTableHead
												order={order}
												orderBy={orderBy}
												onRequestSort={handleRequestSort}
												rowCount={dataAllSales.length}
												columns={keysForVenda}
											/>
											<TableBody>
												{
													//cria uma linha por objeto
													visibleRows
														.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
														.map((row, index) => {
															return (
																<TableRow hover tabIndex={-1} key={index}>
																	{keysForVenda.map((column) => {
																		return (
																			<TableCell
																				key={column}
																				id={row.id}
																				onClick={handleOpenSaleDialog}
																			>
																				{row[column.id]}
																			</TableCell>
																		);
																	})}
																</TableRow>
															);
														})
												}
											</TableBody>
										</Table>
									</TableContainer>
									<TablePagination
										rowsPerPageOptions={[7, 14, 21, { label: "Todos", value: Number.MAX_VALUE }]}
										component="div"
										colSpan={7}
										count={visibleRows.length}
										rowsPerPage={rowsPerPage}
										page={page}
										labelRowsPerPage="Linhas por página"
										SelectProps={{
											inputProps: {
												"aria-label": "rows per page",
											},
											native: false,
										}}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
										ActionsComponent={TablePaginationActions}
									/>
								</ThemeProvider>
							</Paper>
						</Grid>

						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<Item sx={stylesItem}>
								<Grid
									container
									rowSpacing={1}
									columnSpacing={{ xs: 0, sm: 0, md: 0 }}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "end",
										flexDirection: {
											xs: "column-reverse",
											sm: "column-reverse",
											md: "row",
										},
										pt: 2,
									}}
								>
									<Grid size={{ xs: 12, sm: 12, md: 3 }}>
										<Item sx={stylesItem}>
											<button
												type="button"
												onClick={handleCloseSale}
												className={styles.ButtonCancelarModal}
											>
												Cancelar
											</button>
										</Item>
									</Grid>
								</Grid>
							</Item>
						</Grid>
					</Grid>
					<Dialog
						open={openSaleDialog}
						TransitionComponent={Transition}
						keepMounted
						onClose={handleCloseSaleDialog}
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogContent>
							<DialogContentText id="alert-dialog-slide-description">
								Deseja Selecionar essa venda?
							</DialogContentText>
						</DialogContent>
						<DialogActions
							sx={{
								display: "flex",

								flexDirection: "row",
							}}
						>
							<button
								className={styles.ButtonCancelarModal}
								onClick={handleCloseSaleDialog}
							>
								Cancelar
							</button>

							<button
								className={styles.ButtonConfimModal}
								onClick={handleCloseAddSale}
							>
								Selecionar
							</button>
						</DialogActions>
					</Dialog>
				</Box>
			</Modal>
			<Modal
				open={openSaleItem}
				onClose={handleCloseSaleItem}
				aria-labelledby="parent-modal-title"
				aria-describedby="parent-modal-description"
			>
				<Box
					sx={{
						...style,
						width: { xs: "90%", sm: "50%", md: "50%" },
						bgcolor: "white",
						borderRadius: "8px",
						p: 3,
					}}
				>
					<Grid
						container
						rowSpacing={0}
						columnSpacing={{ xs: 0, sm: 2, md: 3 }}
						sx={stylesItem}
						className={styles.registrationInputModal}
					>
						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<div className={styles.titleTabelaModal}>
								<h2>
									<b>Itens da Venda</b>
								</h2>
							</div>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<Paper sx={{ width: "100%", p: 1, m: 0 }}>
								<ThemeProvider theme={theme}>
									<TableContainer sx={{ maxHeight: "46vh" }}>
										<Table stickyHeader>
											<EnhancedTableHead
												order={order1}
												orderBy={orderBy1}
												onRequestSort={handleRequestSort1}
												rowCount={dataAllSaleItems.length}
												columns={keysForVendaItem}
											/>
											<TableBody>
												{
													//cria uma linha por objeto
													visibleRows1
														.slice(page1 * rowsPerPage1, page1 * rowsPerPage1 + rowsPerPage1)
														.map((row, index) => {
															return (
																<TableRow hover tabIndex={-1} key={index}>
																	{keysForVendaItem.map((column) => {
																		return (
																			<TableCell
																				key={column.id}
																				id={row.ordemProducaoId}
																				onClick={handleOpenSaleItemDialog}
																			>
																				{row[column.id]}
																			</TableCell>
																		);
																	})}
																</TableRow>
															);
														})
												}
											</TableBody>
										</Table>
									</TableContainer>
									<TablePagination
										rowsPerPageOptions={[7, 14, 21, { label: "Todos", value: Number.MAX_VALUE }]}
										component="div"
										colSpan={7}
										count={visibleRows1.length}
										rowsPerPage={rowsPerPage1}
										page={page1}
										labelRowsPerPage="Linhas por página"
										SelectProps={{
											inputProps: {
												"aria-label": "rows per page",
											},
											native: false,
										}}
										onPageChange={handleChangePage1}
										onRowsPerPageChange={handleChangeRowsPerPage1}
										ActionsComponent={TablePaginationActions}
									/>
								</ThemeProvider>
							</Paper>
						</Grid>

						<Grid size={{ xs: 12, sm: 12, md: 12 }}>
							<Item sx={stylesItem}>
								<Grid
									container
									rowSpacing={1}
									columnSpacing={{ xs: 0, sm: 0, md: 0 }}
									sx={{
										display: "flex",
										alignItems: "center",
										justifyContent: "end",
										flexDirection: {
											xs: "column-reverse",
											sm: "column-reverse",
											md: "row",
										},
										pt: 2,
									}}
								>
									<Grid size={{ xs: 12, sm: 12, md: 3 }}>
										<Item sx={stylesItem}>
											<button
												type="button"
												onClick={handleCloseSaleItem}
												className={styles.ButtonCancelarModal}
											>
												Cancelar
											</button>
										</Item>
									</Grid>
								</Grid>
							</Item>
						</Grid>
					</Grid>
					<Dialog
						open={openSaleItemDialog}
						TransitionComponent={Transition}
						keepMounted
						onClose={handleCloseSaleItemDialog}
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogContent>
							<DialogContentText id="alert-dialog-slide-description">
								Deseja Selecionar esse item?
							</DialogContentText>
						</DialogContent>
						<DialogActions
							sx={{
								display: "flex",

								flexDirection: "row",
							}}
						>
							<button
								className={styles.ButtonCancelarModal}
								onClick={handleCloseSaleItemDialog}
							>
								Cancelar
							</button>

							<button
								className={styles.ButtonConfimModal}
								onClick={handleCloseAddSaleItem}
							>
								Selecionar
							</button>
						</DialogActions>
					</Dialog>
				</Box>
			</Modal>
		</AppLayout>
	);
}

export default Tag;
